var map = {
	"./add.svg": 21603,
	"./alipay.svg": 4708,
	"./arrdown.svg": 56787,
	"./arrleft.svg": 7620,
	"./arrup.svg": 21836,
	"./article-create.svg": 86613,
	"./article-ranking.svg": 70337,
	"./article.svg": 93672,
	"./audit.svg": 31223,
	"./bankcard.svg": 1670,
	"./bankcard1.svg": 96891,
	"./base-data.svg": 11106,
	"./bell.svg": 72221,
	"./binding.svg": 12221,
	"./blocked.svg": 85426,
	"./brandshop.svg": 90113,
	"./cart-down.svg": 18777,
	"./change-theme.svg": 37250,
	"./chart.svg": 31762,
	"./close.svg": 8298,
	"./cloth.svg": 25926,
	"./cloth1.svg": 86459,
	"./colapse.svg": 99859,
	"./collapse.svg": 28111,
	"./copy.svg": 42605,
	"./dashboard.svg": 15582,
	"./data-upload.svg": 1396,
	"./delete.svg": 84295,
	"./diagnosis.svg": 32909,
	"./disabled.svg": 91462,
	"./disdroy.svg": 39760,
	"./down.svg": 58374,
	"./download.svg": 3614,
	"./download2.svg": 912,
	"./edit.svg": 89402,
	"./empty.svg": 94437,
	"./error.svg": 16660,
	"./example.svg": 93324,
	"./exit-fullscreen.svg": 41656,
	"./expand.svg": 15554,
	"./expaned.svg": 71797,
	"./eye-open.svg": 19582,
	"./eye.svg": 77425,
	"./financial.svg": 26399,
	"./fullscreen.svg": 24005,
	"./getback.svg": 90743,
	"./gouxuan.svg": 41397,
	"./group.svg": 68703,
	"./guide.svg": 17950,
	"./hamburger-closed.svg": 98664,
	"./hamburger-opened.svg": 97515,
	"./histoires.svg": 15836,
	"./image.svg": 13861,
	"./info.svg": 22374,
	"./international.svg": 58298,
	"./introduce.svg": 28105,
	"./inventory.svg": 8098,
	"./language.svg": 4192,
	"./link.svg": 6406,
	"./loading.svg": 24178,
	"./medtruansfer.svg": 62308,
	"./myreg.svg": 91786,
	"./nested.svg": 96983,
	"./new.svg": 31772,
	"./next.svg": 80029,
	"./outlinepay.svg": 49054,
	"./outorder.svg": 99098,
	"./package.svg": 61542,
	"./password.svg": 46605,
	"./permission.svg": 81279,
	"./personnel-info.svg": 5999,
	"./personnel-manage.svg": 834,
	"./personnel.svg": 20822,
	"./prev.svg": 23717,
	"./refresh.svg": 643,
	"./require.svg": 87303,
	"./reward.svg": 79127,
	"./role.svg": 7214,
	"./save.svg": 12237,
	"./search.svg": 30486,
	"./setting.svg": 21690,
	"./setting1.svg": 81559,
	"./shared.svg": 75557,
	"./shift.svg": 95270,
	"./size.svg": 67769,
	"./size1.svg": 65914,
	"./success.svg": 13551,
	"./table.svg": 20578,
	"./tel.svg": 32921,
	"./tree.svg": 88682,
	"./up.svg": 73053,
	"./upload.svg": 42773,
	"./user.svg": 52815,
	"./video.svg": 93043,
	"./viewer.svg": 98168,
	"./warn.svg": 91294,
	"./wechat.svg": 41008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;